<!--//Created by keni.-->
<!--//User: keni-->
<!--//Date: 23/02/2018-->
<!--//Time: 23:49-->
<!--https://codepen.io/desandro/pen/vLLeJM-->
<template>
    <div>

        <!--<ul class="nav justify-content-end">-->
        <!--<li class="nav-item">-->
        <!--<a class="nav-link active" href="#">Modules</a>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<a class="nav-link" href="#">Link</a>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<a class="nav-link" href="#">Link</a>-->
        <!--</li>-->
        <!--<li class="nav-item">-->
        <!--<a class="nav-link disabled" href="#">Disabled</a>-->
        <!--</li>-->
        <!--</ul>-->
        <sales-total-by-event
                :progress_bar_height="progress_bar_height"
                :request_route_uri="request_route_uri"
                :sale_route_name="sale_route_name"
                :sale_route_uri="sale_route_uri"
                title="Sales by event"
                :filter_date="filter_date"
                @open_calendar="triggerCalendar"
        ></sales-total-by-event>

        <traffic-module></traffic-module>

       <div v-if="show_the_bottom === true">
           <template v-if="show_masonry === true">
               <div v-if="loadingDataSet.loaded">
                   <div class="progress">
                       <div class="progress-bar w-25" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                   </div>
               </div>
               <div v-else
                    class="masonry"
                    :ref="masonry_id"
               >
                   <!-- 2 col grid @ xs, 3 col grid @ sm, 4 col grid @ md -->
                   <div class="masonry-sizer col-xs-6 col-sm-4 col-md-3"></div>
                   <!-- 1 col @ xs, 2 col @ sm, 2 col @ md is col-xs-6 col-sm-8 col-md-6-->
                   <!-- 1 col @ xs, 1 col @ sm, 1 col @ md is col-xs-6 col-sm-4 col-md-3-->
                   <div v-for="dashboard in dashboards" class="masonry-item"
                        :class="{
                'col-12 col-sm-12 col-md-6':dashboard.type === moduleNames.sales || dashboard.type === moduleNames.graph,
                'col-6 col-sm-6 col-md-3':dashboard.type === moduleNames.count,
            }"
                   >
                       <div class="masonry-item--content dashboard-module ">

                           <!--:parameters="dashboard"-->
                           <!--:items="dashboard.items"-->
                           <!--:filter_date="dashboard.filter_date"-->
                           <graph-list-module v-if="dashboard.type === moduleNames.graph"
                                              :sale_route_name="sale_route_name"
                                              :laravel_route_uri="laravel_route_uri"
                                              :request_route_uri="request_route_uri"
                                              :parameters="dashboard"
                                              :filter_date="dashboard.filter_date"
                                              :load_items="load_items"
                                              read_request="false"

                                              @child_loaded="childrenLoaded"
                                              @open_calendar="triggerCalendar"
                                              @layout_changed="layoutChanged"
                           ></graph-list-module>
                           <sales-module-small v-if="dashboard.type === moduleNames.sales"
                                               :laravel_route_uri="laravel_route_uri"
                                               :request_route_uri="request_route_uri"
                                               :parameters="dashboard"
                                               :filter_date="dashboard.filter_date"
                                               :load_items="load_items"
                                               read_request="false"
                                               @child_loaded="childrenLoaded"
                                               @open_calendar="triggerCalendar"
                                               @layout_changed="layoutChanged"
                           ></sales-module-small>
                           <single-count-module v-if="dashboard.type === moduleNames.count"
                                                :laravel_route_uri="laravel_route_uri"
                                                :request_route_uri="request_route_uri"
                                                :load_items="load_items"
                                                @open_calendar="triggerCalendar"
                                                :filter_date="dashboard.filter_date"
                                                @layout_changed="layoutChanged"
                           ></single-count-module>
                       </div>
                   </div>
               </div>
           </template>

       </div>

        <date-chooser @date_selected="dateSelected"
                :settings="dateChooser"
                :trigger_open="dateChooser.display"
        ></date-chooser>
    </div>
</template>

<script>
	// let Isotope = require('isotope-layout'); // not compatible with bootstrap 4

	import {_} from 'underscore';
	import Masonry from 'masonry-layout';
	import {uniqueId} from "../../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds";

	Vue.component('traffic-module', require('../../modules/TrafficModule'));
	Vue.component('graph-list-module', require('../../modules/GraphListModule'));
	Vue.component('sales-module-small', require('../../modules/SalesModuleSmall'));
	Vue.component('single-count-module', require('../../modules/SingleCountModule'));
	Vue.component('date-chooser', require('../../forms/DateChooser'));
	Vue.component('sales-total-by-event',require('../../modules/SalesTotalByEvent'));
	export default {
		name: "client-dashboard",
		components: {},
		props: {
			laravel_route_uri: String,
			request_route_uri: String,
			sale_route_name: String,
			sale_route_uri: String,
			type: String,
			progress_bar_height: String

		},
		created() {
		},
		destroyed() {
		},
		mounted() {
			let _this = this;
			// console.log('this.dashboards', this.dashboards);
			// not compatible with bootstrap 4
			this.$nextTick(function () {
				_this.report()
					.then(function () {
						// console.log('_this',_this);
						_this.load_items = !_this.load_items;

						_this.layoutChanged();
					});
				// setTimeout(function () {
				// 	_this.layoutChanged();
				// }, 2500)
			});
		},
		data() {
			return {
			    show_masonry:false,
			    show_the_bottom:false,
				filter_date:'',
				load_items: false,
				loadingDataSet: {
					progress: 0,
					loaded: false
				},
				dashboards: Array,
				dateChooser: {
					show_form: false,
					display: false,
					dashboard_index: -1
				},
				masonry_params: {
					itemSelector: '.masonry-item',
					columnWidth: '.masonry-sizer',
					percentPosition: true,
					stagger: 50,
					transitionDuration: '0.8s'
				},
				masonry: {},
				masonry_id: uniqueId(),
				childrenRendered: 0,
				moduleNames: {
					graph: 'graph-list-module',
					sales: 'sales-module-small',
					count: 'single-count-module'
				},
				bgColors: [
					'pink darken-3 light-text',
					'purple darken-4 light-text',
					'red darken-4 light-text',
					'deep-purple lighten-1 light-text',
					'indigo lighten-1 light-text',
					'blue darken-1 light-text',
					'light-blue darken-1 light-text',
					'cyan lighten-1',
					'teal',
					'green darken-1 light-text',
					'light-green darken-1 light-text',
					'orange',
					'grey darken-1 light-text'
				],
				requestData: []
			}
		},
		methods: {
			layoutComplete() {
				let _this = this;

				_this.masonry.layout();
			},
			listModules() {

			},
			loadedProgress() {

			},
			triggerCalendar(indexObj) {
				let _this = this;

				_this.dateChooser.display = !_this.dateChooser.display;
				_this.dateChooser.dashboard_index = indexObj.index;

			},
			dateSelected(value) {
				// console.log('dateSelected', value, 'this.dateChooser.dashboard_index', this.dateChooser.dashboard_index);
				let _this = this;

				for (let i = 0; i < _this.dashboards.length; i++) {
					let dashboard = _this.dashboards[i];
					// console.log('dateSelected', 'dashboard',dashboard);
					dashboard.filter_date = value;
				}
				_this.filter_date = value;
				/**
				 * update the dashboards thing
				 */
				// _this.dashboards[this.dateChooser.dashboard_index].filter_date = value;

			},
			layoutChanged() {
			    if(!this.show_masonry){
			        return false;
                }
				let _this = this;

				_this.masonry = new Masonry(_this.$refs[_this.masonry_id], _this.masonry_params);

				_this.masonry.on('layoutComplete', this.layoutComplete());
			},

			childrenLoaded(component) {
				this.childrenRendered = ++this.childrenRendered;

				// console.log(component,'childrenLoaded', this.childrenRendered,this.dashboards.length);
				if (this.childrenRendered == this.dashboards.length) {

				}
			},
			createBackground(dashboard) {
				return this.bgColors[_.random(0, this.bgColors.length - 1)];
			},
			report() {
				console.log('report', 'requesting');
				let _this = this,
					data = {
						type: _this.type,
						view: 'dashboards'
					};

				// console.log('read() data', data);
				return axios.post(this.request_route_uri, data)
					.then(function (response) {
						// console.log('response.data', response.data);
						if (response.data.success) {
							_this.dashboards = response.data.dashboards;

							// console.log('read() response.data', response.data);
							for (let i = 0; i < _this.dashboards.length; i++) {
								// console.log('dashboard.data_type',dashboard.data_type);
								// _this.dashboards[i].items = response.data.sales;
								_this.dashboards[i].index = i;
							}
							// _this.loadingDataSet = false;
						}
						// console.log('_this.dashboards', _this.dashboards);
						return _this;
					})
					.catch(function (e) {
						console.error('e', e);
					});
			}
		}
		,
		computed: {}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/dashboards/ClientDashboard.vue?b367791e